import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import AuthLayout, { Field, Message } from './AuthLayout';
import Button from '../components/Button';
import { accent } from '../theme';

export default function LogIn() {
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    const { error } = await signIn(email, password);
    setBusy(false);
    if (error) setError(error.message);
    else navigate('/hub', { replace: true });
  }

  return (
    <AuthLayout
      eyebrow="Welcome back"
      title="Log in."
      footer={<>No account yet? <Link to="/signup" style={{ color: accent.lime }}>Sign up</Link></>}
    >
      <Message tone="error">{error}</Message>

      <form onSubmit={handleSubmit}>
        <Field
          label="Email"
          type="email"
          value={email}
          autoComplete="email"
          onChange={e => setEmail(e.target.value)}
          placeholder="you@email.com"
          required
        />
        <Field
          label="Password"
          type="password"
          value={password}
          autoComplete="current-password"
          onChange={e => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />
        <Button type="submit" disabled={busy} style={{ width: '100%', justifyContent: 'center' }}>
          {busy ? 'Logging in\u2026' : 'Log in'}
        </Button>
      </form>
    </AuthLayout>
  );
}
